"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlertContent = exports.StyledAlertText = exports.StyledAlertTitle = exports.StyledIcon = exports.StyledAlert = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./alert.types");
exports.StyledAlert = theme_1.styled.div `
  display: flex;
  padding: 12px;
  color: ${({ theme }) => theme.colors.text.primary};
  box-sizing: border-box;
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 4)`; }};

  background-color: ${({ type, theme }) => {
    switch (type) {
        case 'warning':
            return theme.colors.accent.warning.faded;
        case 'info':
            return theme.colors.neutral[10];
        case 'error':
            return theme.colors.accent.error.faded;
        case 'benefit':
            return theme.colors.surface.interactive['interactive-light'];
        default:
            return 'transparent';
    }
}};

  ${({ type }) => {
    if (type === 'error' || type === 'warning')
        return (0, theme_1.css) `
        border: 2px solid
          ${({ theme }) => {
            switch (type) {
                case 'error':
                    return theme.colors.accent.error.normal;
                case 'warning':
                    return theme.colors.accent.warning.normal;
            }
        }};
      `;
}};

  ${({ type, theme }) => {
    var _a;
    return type === 'outlined'
        ? (0, theme_1.css) `
          border: 1px solid ${(_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.neutral['30']};
          column-gap: 12px;
          align-items: center;
        `
        : (0, theme_1.css) `
          column-gap: 8px;
        `;
}};
`;
exports.StyledIcon = theme_1.styled.div `
  display: flex;
  flex-shrink: 0;

  & > * {
    max-width: 24px;
    max-height: 24px;
  }

  ${({ type, theme }) => {
    switch (type) {
        case 'outlined':
            return (0, theme_1.css) `
          padding: 12px;
          background-color: ${theme.colors.surface.interactive['interactive-light']};
          border-radius: calc(${({ theme }) => theme.common.radius} * 3);
          color: ${theme.colors.icon.primary};
        `;
        case 'error':
            return (0, theme_1.css) `
          color: ${({ theme }) => theme.colors.icon.error};
        `;
        case 'warning':
            return (0, theme_1.css) `
          color: ${({ theme }) => theme.colors.icon.warning};
        `;
    }
}}
`;
exports.StyledAlertTitle = theme_1.styled.div `
  font-weight: 500;
  line-height: 24px;
`;
exports.StyledAlertText = theme_1.styled.div `
  ${theme_1.typography.regular16}
  line-height: 24px;
`;
exports.StyledAlertContent = theme_1.styled.div `
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;
